import React, { useState } from 'react';
import { FaChevronDown } from '../../../icons/index';
import styles from './ApproachMethos.module.scss';

export default function CommonAccordion({ title, subtitle, description, accordionItems }) {
    const [activeIndex, setActiveIndex] = useState(0);

    const toggleAccordion = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    return (
        <section className={styles.approachContainer}>
            <div className={styles.container}>
                <div className={styles.left}>
                    <h2>
                        {title} <span>{subtitle}</span> Approach
                    </h2>
                    <p>{description}</p>
                </div>

                <div className={styles.right}>
                    {accordionItems.map((item, index) => (
                        <div
                            key={index}
                            className={`${styles.accordionItem} ${activeIndex === index ? styles.active : ''}`}
                        >
                            <div className={styles.accordionHeader} onClick={() => toggleAccordion(index)}>
                                <h3 className={styles.activeHeader}> {item.title}</h3>
                                <FaChevronDown className={styles.icon} />
                            </div>
                            {activeIndex === index && (
                                <div className={styles.accordionContent}>
                                    <p>{item.content}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
